import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Problem() {
  return <section className="w-full bg-black text-white py-20 md:py-32 px-4" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-93">
          <h2 className="text-4xl md:text-6xl font-black mb-12" data-id="element-94">
            El problema no sos vos
          </h2>

          <div className="space-y-6 mb-12 text-left max-w-2xl mx-auto" data-id="element-95">
            <div className="flex items-start gap-4" data-id="element-96">
              <XIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-97" />
              <p className="text-xl md:text-2xl" data-id="element-98">Dependés de la motivación</p>
            </div>
            <div className="flex items-start gap-4" data-id="element-99">
              <XIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-100" />
              <p className="text-xl md:text-2xl" data-id="element-101">
                Intentás cambiar todo de golpe
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-102">
              <XIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-103" />
              <p className="text-xl md:text-2xl" data-id="element-104">No tenés un plan claro</p>
            </div>
          </div>

          <div className="bg-red-900/30 border-2 border-red-500 rounded-xl p-8" data-id="element-105">
            <p className="text-2xl md:text-3xl font-bold" data-id="element-106">
              Empezás fuerte → perdés constancia → abandonás
            </p>
            <p className="text-xl md:text-2xl mt-4" data-id="element-107">Y repetís el ciclo.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}